import React, { useState } from 'react';
import PropTypes from 'prop-types';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import sleep from 'shared-utils/src/sleep';

import Chevron from 'shared-vectors/icons/MapColumnsCollapse';
import { Icon } from 'shared-vectors';

import WithTooltip from '../WithTooltip';

const CollapseColumnsBtn = ({ columns, unsetHighlightedListMarker, device }) => {
  const [pointIn, setPointIn] = useState(true);
  const collapse = () => {
    unsetHighlightedListMarker(null);
    sleep(300).then(() => trackGTMEvents({
      category: 'Interaction',
      action: pointIn ? 'HideListing' : 'ShowListing',
    }));
    setPointIn(!pointIn);
    columns.current.collassa();
  };
  return (
    <WithTooltip
      tooltipText={pointIn ? 'Allarga mappa' : 'Mostra seconda colonna'}
      tooltipCls="csa_mapsearch__bod__tools__collapse"
      baloonPosition="right"
      baloonCls="tooltip"
      device={device}
    >
      <button
        type="button"
        id="collapse"
        className="csa_mapsearch__bod__tools__collapse__btn c-bg--w b--0 is-clickable c-txt--f0"
        onClick={collapse}
      >
        <Icon name={Chevron} width="24px" fill className={!pointIn ? 'out' : ''} />
      </button>
    </WithTooltip>
  );
};

export default CollapseColumnsBtn;

CollapseColumnsBtn.propTypes = {
  columns: PropTypes.instanceOf(Object),
  unsetHighlightedListMarker: PropTypes.func,
  device: PropTypes.string,
};

CollapseColumnsBtn.defaultProps = {
  columns: null,
  unsetHighlightedListMarker: () => {},
  device: '',
};
